import { ReactComponent as Clock } from '../assets/icons/clock-regular.svg';
import { ReactComponent as Eye } from '../assets/icons/eye-solid.svg';
import { ReactComponent as RainFall } from '../assets/icons/noun-rainfall-217514.svg';
import { ReactComponent as Water } from '../assets/icons/noun-water-6191907.svg';
import { ReactComponent as Cloudy } from '../assets/icons/partly-cloudy.svg';
import { ReactComponent as RainyCloud } from '../assets/icons/rainy-cloud.svg';
import { ReactComponent as Temperature } from '../assets/icons/temperature-half-solid.svg';
import { ReactComponent as Wind } from '../assets/icons/wind-solid.svg';
import { ReactComponent as Calendar } from '../assets/icons/calendar-solid.svg';
import { ReactComponent as FirstIconDay } from '../assets/icons/01d.svg';
import { ReactComponent as SecondIconDay } from '../assets/icons/02d.svg';
import { ReactComponent as ThirdIconDay } from '../assets/icons/03d.svg';
import { ReactComponent as FourthIconDay } from '../assets/icons/04d.svg';
import { ReactComponent as NinthIconDay } from '../assets/icons/09d.svg';
import { ReactComponent as TenthIconDay } from '../assets/icons/10d.svg';
import { ReactComponent as EleventhIconDay } from '../assets/icons/11d.svg';
import { ReactComponent as ThrteenthIconDay } from '../assets/icons/13d.svg';
import { ReactComponent as FiftiethIconDay } from '../assets/icons/50d.svg';
import { ReactComponent as FirstIconNight } from '../assets/icons/01n.svg';
import { ReactComponent as SecondIconNight } from '../assets/icons/02n.svg';
import { ReactComponent as ThirdIconNight } from '../assets/icons/03n.svg';
import { ReactComponent as FourthIconNight } from '../assets/icons/04n.svg';
import { ReactComponent as NinthIconNight } from '../assets/icons/09n.svg';
import { ReactComponent as TenthIconNight } from '../assets/icons/10n.svg';
import { ReactComponent as EleventhIconNight } from '../assets/icons/11n.svg';
import { ReactComponent as ThrteenthIconNight } from '../assets/icons/13n.svg';
import { ReactComponent as FiftiethIconNight } from '../assets/icons/50n.svg';

export const icons = {
	clock: <Clock />,
	eye: <Eye />,
	rainFall: <RainFall />,
	water: <Water />,
	cloudy: <Cloudy />,
	rainyCloud: <RainyCloud />,
	temperature: <Temperature />,
	wind: <Wind />,
	calendar: <Calendar />,
	'01d': <FirstIconDay />,
	'02d': <SecondIconDay />,
	'03d': <ThirdIconDay />,
	'04d': <FourthIconDay />,
	'09d': <NinthIconDay />,
	'10d': <TenthIconDay />,
	'11d': <EleventhIconDay />,
	'13d': <ThrteenthIconDay />,
	'50d': <FiftiethIconDay />,

	'01n': <FirstIconNight />,
	'02n': <SecondIconNight />,
	'03n': <ThirdIconNight />,
	'04n': <FourthIconNight />,
	'09n': <NinthIconNight />,
	'10n': <TenthIconNight />,
	'11n': <EleventhIconNight />,
	'13n': <ThrteenthIconNight />,
	'50n': <FiftiethIconNight />,
};
